module.exports = __webpack_public_path__ + "img/tenlife-normal-logo.43ea159.png";